import React, { useState } from 'react'
import { css } from '@emotion/core';
import {priceFormatter as formatter} from 'src/util';
import Product from './Product';

export default (props) => (
  <Product {...props} inputType="checkbox" />
);
